import useSWR from "swr";
import { getValidValues } from "../services/template-service";
import type { ValidValuesResponse, ValidValueItem } from "../types/api-types";

export interface UseValidValuesReturn {
  validValues: ValidValueItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: () => void;
}

const useValidValues = (templateId: number | null): UseValidValuesReturn => {
  const { data, error, isLoading, mutate } = useSWR<ValidValuesResponse>(
    templateId ? `valid-values-${templateId}` : null,
    () => (templateId ? getValidValues(templateId) : Promise.resolve([])),
  );

  return {
    validValues: data,
    isLoading,
    error,
    mutate,
  };
};

export default useValidValues;
